import { render } from "./ProductCardCarousel.vue?vue&type=template&id=2aba6b2b"
import script from "./ProductCardCarousel.vue?vue&type=script&lang=js"
export * from "./ProductCardCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__